import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';
import { CompanyService } from '../../core/services/company/company.service';
import { SnackbarService } from '../../core/services/snackbar/snackbar.service';
import {
  addAddress,
  addAddressFailed,
  addCityPermits,
  addCityPermitsFailed,
  addContacts,
  addContactsFailed,
  addInsurancePolicy,
  addInsurancePolicyFailed,
  companyDataSubmit,
  companyDataSubmitFailed,
  companyEditDataSubmit,
  companyOwnerCities,
  companyOwnerCitiesFailed,
  companyOwnerCitiesReceived,
  deleteAddress,
  deleteAddressFailed,
  deleteCityPermits,
  deleteCityPermitsFailed,
  deleteContacts,
  deleteContactsFailed,
  deleteInsurancePolicy,
  deleteInsurancePolicyFailed,
  editAddress,
  editAddressFailed,
  editCityPermits,
  editCityPermitsFailed,
  editContacts,
  editContactsFailed,
  editInsurancePolicy,
  editInsurancePolicyFailed,
  fetchCompanyData,
  fetchCompanyDataFailed,
  fetchCompanyDataSuccessful,
  getAddress,
  getAddressFailed,
  getAddressReceived,
  getCityPermits,
  getCityPermitsFailed,
  getCityPermitsReceived,
  getComments,
  getCommentsFailed,
  getCommentsReceived,
  getContacts,
  getContactsReceived,
  getInsurancePolicy,
  getInsurancePolicyFailed,
  getInsurancePolicyReceived,
  getUnviewedCount,
  getUnviewedCountFailed,
  getUnviewedCountReceived,
} from '../actions/companyAction';
import { loginReceived } from '../actions/loginAction';
import { DatePipe } from '@angular/common';
import { showPopup } from '../actions/operatingAuthorityAction';
@Injectable()
export class companyEffect {
  constructor(
    private actions: Actions,
    private companyService: CompanyService,
    private snackbarService: SnackbarService,
    private datePipe: DatePipe,
  ) {}
  companyDetailsSubmit$ = createEffect(() =>
    this.actions.pipe(
      ofType(
        companyDataSubmit,
        fetchCompanyData,
        companyEditDataSubmit,
        companyOwnerCities,
        addContacts,
        getContacts,
        editContacts,
        deleteContacts,
        addAddress,
        getAddress,
        editAddress,
        deleteAddress,
        getComments,
        getCityPermits,
        addCityPermits,
        editCityPermits,
        deleteCityPermits,
        getInsurancePolicy,
        addInsurancePolicy,
        editInsurancePolicy,
        deleteInsurancePolicy,
        getUnviewedCount,
      ),
      mergeMap((params) => {
        const userData: any = JSON.parse(
          localStorage.getItem('userData') || '',
        );
        if (params.type === 'company-details-submit') {
          return this.companyService
            .companyDetailsSubmitService(params, userData?.sessionHash)
            .pipe(
              map((data) => {
                userData.missingCompanyInformation = false;
                this.snackbarService.success(
                  'Company has been added successfully submitted',
                );
                localStorage.setItem('userData', JSON.stringify(userData));
                return loginReceived({ data: userData });
              }),
              catchError((error) => {
                this.snackbarService.handleError(error);
                return of(companyDataSubmitFailed());
              }),
            );
        } else if (params.type === 'fetch-company-details') {
          return this.companyService.getCompanyDetails(params.sessionHash).pipe(
            map((data) => {
              return fetchCompanyDataSuccessful({ params: data });
            }),
            catchError((error) => of(fetchCompanyDataFailed())),
          );
        } else if (params.type === 'update-company-details') {
          return this.companyService
            .companyEditSubmitService(params, userData?.sessionHash)
            .pipe(
              map((data) => {
                this.snackbarService.success(
                  'Company has been updated successfully',
                );
                localStorage.setItem('userData', JSON.stringify(userData));
                return fetchCompanyData({ sessionHash: userData?.sessionHash });
              }),
              catchError((error) => {
                this.snackbarService.danger(error);
                return of(companyDataSubmitFailed());
              }),
            );
        } else if (params.type === 'company-owner-cities') {
          return this.companyService.getOwnerCities(params).pipe(
            map((data) => {
              return companyOwnerCitiesReceived({ params: data });
            }),
            catchError((error) => of(companyOwnerCitiesFailed())),
          );
        } else if (params.type === 'get-contacts') {
          return this.companyService
            .getContactDetails(userData?.sessionHash)
            .pipe(
              map((data: any) => {
                const updatedContactsData = data?.map((contact: any) => ({
                  ...contact,
                  isMain: contact.isMain ? 'Yes' : 'No',
                  isRegisteredForWeb: contact.isRegisteredForWeb ? 'Yes' : 'No',
                }));
                return getContactsReceived({ params: updatedContactsData });
              }),
              catchError((error) => of(addContactsFailed())),
            );
        } else if (params.type === 'add-contacts') {
          return this.companyService
            .addContacts(params, userData?.sessionHash)
            .pipe(
              map((data) => {
                this.snackbarService.success(
                  'Contact has been Added successfully',
                );
                return getContacts();
              }),
              catchError((error) => {
                this.snackbarService.handleError(error.message);
                return of(addContactsFailed());
              }),
            );
        } else if (params.type === 'edit-contacts') {
          return this.companyService.editContactsService(params).pipe(
            map((data) => {
              this.snackbarService.success(
                'Company Contacts has been updated successfully',
              );
              return getContacts();
            }),
            catchError((error) => {
              this.snackbarService.handleError(error.message);
              return of(editContactsFailed());
            }),
          );
        } else if (params.type === 'delete-contacts') {
          return this.companyService
            .deleteContactsService(params.params, params.contactId)
            .pipe(
              map((data) => {
                this.snackbarService.danger(
                  'Company Contacts has been deleted successfully',
                );
                return getContacts();
              }),
              catchError((error) => {
                this.snackbarService.handleError(error.message);
                return of(deleteContactsFailed());
              }),
            );
        } else if (params.type === 'get-address') {
          return this.companyService
            .getAddressService(userData?.sessionHash)
            .pipe(
              map((data: any) => {
                const updatedAddressesData = data?.map((address: any) => ({
                  ...address,
                  isMain: address.isMain ? 'Yes' : 'No',
                }));
                return getAddressReceived({ params: updatedAddressesData });
              }),
              catchError((error) => of(getAddressFailed())),
            );
        } else if (params.type === 'add-address') {
          return this.companyService
            .addAddressService(params, userData?.sessionHash)
            .pipe(
              map((data) => {
                this.snackbarService.success(
                  'Address has been added successfully',
                );
                return getAddress();
              }),
              catchError((error) => {
                this.snackbarService.handleError(error.message);
                return of(addAddressFailed());
              }),
            );
        } else if (params.type === 'edit-address') {
          return this.companyService.editAddressService(params).pipe(
            map((data) => {
              this.snackbarService.success(
                'Company Addresses has been updated successfully',
              );
              return getAddress();
            }),
            catchError((error) => {
              this.snackbarService.handleError(error.message);
              return of(editAddressFailed());
            }),
          );
        } else if (params.type === 'delete-address') {
          return this.companyService
            .deleteAddressService(params.params, params.addressId)
            .pipe(
              map((data) => {
                this.snackbarService.danger(
                  'Company addresses has been deleted successfully',
                );
                return getAddress();
              }),
              catchError((error) => {
                this.snackbarService.handleError(error.message);
                return of(deleteAddressFailed());
              }),
            );
        } else if (params.type === 'get-comments') {
          return this.companyService
            .getCommentsService(userData?.sessionHash)
            .pipe(
              map((data: any) => {
                const updatedCommentssData = data?.map((comment: any) => ({
                  ...comment,
                  sysDate: comment.sysDate
                    ? this.datePipe.transform(
                        comment.sysDate,
                        'MM/dd/yyyy hh:mm a',
                      )
                    : comment.sysDate,
                  isSystemGenerated: comment.isSystemGenerated ? 'Yes' : 'No',
                }));
                return getCommentsReceived({ params: updatedCommentssData });
              }),
              catchError((error) => of(getCommentsFailed())),
            );
        } else if (params.type === 'get-city-permits') {
          return this.companyService
            .getCityPermitDetails(userData?.sessionHash, params.permitId)
            .pipe(
              map((data: any) => {
                return getCityPermitsReceived({
                  params: data,
                });
              }),
              catchError((error) => of(getCityPermitsFailed())),
            );
        } else if (params.type === 'add-city-permits') {
          return this.companyService
            .addCityPermitsService(params, userData?.sessionHash)
            .pipe(
              mergeMap((data) => {
                this.snackbarService.success(
                  'Company City / State permit has been added successfully',
                );
                return of(
                  getCityPermits({
                    permitId: params.params.permitId,
                  }),
                  showPopup({ params: true }),
                );
              }),
              catchError((error) => {
                this.snackbarService.handleError(error.message);
                return of(addCityPermitsFailed(), showPopup({ params: false }));
              }),
            );
        } else if (params.type === 'edit-city-permits') {
          return this.companyService.editCityPermitsService(params).pipe(
            map((data) => {
              this.snackbarService.success(
                'Company City / State permit has been updated successfully',
              );
              return getCityPermits({
                permitId: params.params.permitId,
              });
            }),
            catchError((error) => {
              this.snackbarService.handleError(error.message);
              return of(editCityPermitsFailed());
            }),
          );
        } else if (params.type === 'delete-city-permits') {
          return this.companyService
            .deleteCityPermitsService(params.params, params.cityPermitId)
            .pipe(
              map((data) => {
                this.snackbarService.danger(
                  'Company City / State permit has been deleted successfully',
                );
                return getCityPermits({
                  permitId: params.permitId,
                });
              }),
              catchError((error) => {
                this.snackbarService.handleError(error.message);
                return of(deleteCityPermitsFailed());
              }),
            );
        } else if (params.type === 'get-insurance-policy') {
          return this.companyService
            .getInsurancePolicyDetails(userData?.sessionHash, params.permitId)
            .pipe(
              map((data: any) => {
                return getInsurancePolicyReceived({
                  params: data,
                });
              }),
              catchError((error) => of(getInsurancePolicyFailed())),
            );
        } else if (params.type === 'add-insurance-policy') {
          return this.companyService
            .addInsurancePolicyService(params, userData?.sessionHash)
            .pipe(
              mergeMap((data) => {
                this.snackbarService.success(
                  'Company ACORD Certificate has been added successfully',
                );
                return of(
                  getInsurancePolicy({
                    permitId: params.params.permitId,
                  }),
                  showPopup({ params: true }),
                );
              }),
              catchError((error) => {
                this.snackbarService.handleError(error.message);
                return of(
                  addInsurancePolicyFailed(),
                  showPopup({ params: false }),
                );
              }),
            );
        } else if (params.type === 'edit-insurance-policy') {
          return this.companyService.editInsurancePolicyService(params).pipe(
            map((data) => {
              this.snackbarService.success(
                'Company ACORD Certificate has been updated successfully',
              );
              return getInsurancePolicy({
                permitId: params.params.permitId,
              });
            }),
            catchError((error) => {
              this.snackbarService.handleError(error.message);
              return of(editInsurancePolicyFailed());
            }),
          );
        } else if (params.type === 'delete-insurance-policy') {
          return this.companyService
            .deleteInsurancePolicyService(params.params)
            .pipe(
              map((data) => {
                this.snackbarService.danger(
                  'Company ACORD Certificate has been deleted successfully',
                );
                return getInsurancePolicy({
                  permitId: params.params.referenceId,
                });
              }),
              catchError((error) => {
                this.snackbarService.handleError(error.message);
                return of(deleteInsurancePolicyFailed());
              }),
            );
        } else if (params.type === 'get-unviewed-count') {
          return this.companyService
            .getUnviewedCountService(userData?.sessionHash)
            .pipe(
              map((data: any) => {
                return getUnviewedCountReceived({
                  params: data,
                });
              }),
              catchError((error) => of(getUnviewedCountFailed())),
            );
        }
        return of({ type: '[Company API] Unknown Action' });
      }),
    ),
  );
}
